import content from "@/content/site-content.json";
import type { SiteContent } from "@/types/content";

const { about } = content as SiteContent;

export default function About() {
  return (
    <section id="om-oss" className="section about">
      <div className="container about__inner">
        <p className="eyebrow">{about.eyebrow}</p>
        <h2>{about.title}</h2>
        <div className="about__body">
          {about.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>
      <style>{`
        .about {
          background: var(--color-paper);
          border-radius: var(--radius-lg);
          margin: 0 var(--space-2);
        }
        .about__inner {
          max-width: 760px;
        }
        .about__body p {
          font-size: 1.05rem;
        }
      `}</style>
    </section>
  );
}
